const MULTIPLIER = 1000;

export const getCountDown = (date: number): number => date * MULTIPLIER - new Date().getTime();
